/* ============================================================
 * calo-opt-a11y.js -- Paket C3-a11y / Massnahme R-25 (27.09.26)
 * CaloShop Optimierung, additiv, rein additiv umgesetzt.
 *
 * Macht, OHNE bestehendes Verhalten zu aendern:
 *
 * 1) GemPages-Akkordeons (.gp-accordion-item_header) per Tastatur
 *    und Screenreader bedienbar:
 *    - entfernt das nackte aria-hidden-Attribut am Header (das
 *      versteckt sonst Frage + Icon komplett aus dem
 *      Accessibility-Tree)
 *    - setzt role="button" und tabindex="0"
 *    - verknuepft Header und Panel per aria-controls
 *    - haelt aria-expanded synchron zum tatsaechlichen Auf/Zu-Zustand
 *      des Panels (per MutationObserver). WICHTIG (live geprueft,
 *      27.09.26 per playwright-cli-Injektion auf /pages/faq): das
 *      server-gerenderte data-show="false" wird von GemPages'
 *      eigenem Hydration-Skript innerhalb von Sekundenbruchteilen
 *      entfernt; danach steuert GemPages den Zustand ausschliesslich
 *      ueber die Inline-Style-Eigenschaft max-height (0px = zu,
 *      gesetzt-aber-nicht-0px/entfernt = offen). Das Skript nutzt
 *      data-show nur als Fallback, solange es zufaellig noch da ist,
 *      und danach max-height bzw. hilfsweise die gerenderte Hoehe
 *      (offsetHeight) -- alles rein lesend, keine eigene Toggle-Logik.
 *    - Enter/Leertaste loesen header.click() aus -- nutzt damit
 *      GemPages' eigene Toggle-Logik, baut sie nicht nach, kann
 *      also nicht doppelt toggeln
 *
 * 2) Mengensteller (gp-product-quantity) bekommen deutsche
 *    aria-label/title: "Menge verringern" / "Menge" / "Menge
 *    erhoehen" statt "decrement" / "quantity" / "increment".
 *
 * 3) Beide Gruppen bekommen ueber calo-opt-a11y.liquid einen
 *    sichtbaren :focus-visible-Ring (2px, #018673) -- nur fuer
 *    die hier neu fokussierbaren bzw. neu beschrifteten Elemente,
 *    kein globaler Eingriff in bestehende Fokus-Stile.
 *
 * Sofort abschaltbar: die render-Zeile in
 * snippets/calo-opt-a11y.liquid entfernen bzw. das insert_before
 * in layout/theme.liquid und layout/theme.gempages.header.liquid
 * zurueckbauen. Das Skript legt nur zusaetzliche Attribute/Klassen
 * an (data-calo-a11y als Idempotenz-Marker), es entfernt oder
 * ueberschreibt keine bestehenden Klassen, IDs, Preise oder Texte
 * ausserhalb von aria-label/title auf dem Mengensteller.
 * ============================================================ */
(function () {
  'use strict';

  function enhanceAccordions(root) {
    var headers = root.querySelectorAll('.gp-accordion-item_header:not([data-calo-a11y])');
    for (var idx = 0; idx < headers.length; idx++) {
      (function (header) {
        header.setAttribute('data-calo-a11y', '1');

        // Panel: im GemPages-Markup der direkte Folge-Sibling
        // innerhalb desselben .gp-accordion-item-Wrappers.
        var body = null;
        var parent = header.parentElement;
        if (parent) {
          var siblings = parent.children;
          for (var i = 0; i < siblings.length; i++) {
            if (siblings[i] !== header && siblings[i].classList.contains('gp-accordion-item_body')) {
              body = siblings[i];
              break;
            }
          }
        }

        if (header.hasAttribute('aria-hidden')) {
          header.removeAttribute('aria-hidden');
        }

        header.setAttribute('role', 'button');
        if (!header.hasAttribute('tabindex')) {
          header.setAttribute('tabindex', '0');
        }
        header.classList.add('calo-a11y-accordion-header');

        function isPanelOpen(panel) {
          // Reihenfolge: data-show (SSR-Anfangszustand, verschwindet
          // nach GemPages-Hydration) -> style.maxHeight (laufender
          // Betrieb) -> gerenderte Hoehe als letzter Fallback.
          if (panel.hasAttribute('data-show')) {
            return panel.getAttribute('data-show') === 'true';
          }
          var mh = panel.style.maxHeight;
          if (mh === '0px' || mh === '0') {
            return false;
          }
          if (mh) {
            return true;
          }
          return panel.offsetHeight > 0;
        }

        function syncExpanded() {
          var open = body ? isPanelOpen(body) : false;
          header.setAttribute('aria-expanded', open ? 'true' : 'false');
        }

        if (body) {
          var uid = header.getAttribute('uid') || header.id || ('calo-a11y-' + Math.random().toString(36).slice(2));
          if (!body.id) {
            body.id = 'calo-a11y-panel-' + uid;
          }
          header.setAttribute('aria-controls', body.id);
          syncExpanded();
          if ('MutationObserver' in window) {
            try {
              var obs = new MutationObserver(syncExpanded);
              obs.observe(body, { attributes: true, attributeFilter: ['data-show', 'style'] });
            } catch (e) { /* Beobachten nicht moeglich: Erstzustand bleibt gesetzt */ }
          }
        } else {
          header.setAttribute('aria-expanded', 'false');
        }

        header.addEventListener('keydown', function (e) {
          var key = e.key || '';
          if (key === 'Enter' || key === ' ' || key === 'Spacebar' || e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault();
            header.click();
          }
        });
      })(headers[idx]);
    }
  }

  function enhanceQuantitySteppers(root) {
    var minus = root.querySelectorAll(
      'button[aria-label="decrement"]:not([data-calo-a11y]), button[title="Decrement"]:not([data-calo-a11y])'
    );
    for (var i = 0; i < minus.length; i++) {
      var b = minus[i];
      b.setAttribute('data-calo-a11y', '1');
      b.setAttribute('aria-label', 'Menge verringern');
      b.setAttribute('title', 'Menge verringern');
      b.classList.add('calo-a11y-qty-control');
    }

    var plus = root.querySelectorAll(
      'button[aria-label="increment"]:not([data-calo-a11y]), button[title="Increment"]:not([data-calo-a11y])'
    );
    for (var j = 0; j < plus.length; j++) {
      var p = plus[j];
      p.setAttribute('data-calo-a11y', '1');
      p.setAttribute('aria-label', 'Menge erhöhen');
      p.setAttribute('title', 'Menge erhöhen');
      p.classList.add('calo-a11y-qty-control');
    }

    var qty = root.querySelectorAll('input[aria-label="quantity"]:not([data-calo-a11y])');
    for (var k = 0; k < qty.length; k++) {
      var inp = qty[k];
      inp.setAttribute('data-calo-a11y', '1');
      inp.setAttribute('aria-label', 'Menge');
      inp.classList.add('calo-a11y-qty-control');
    }
  }

  function enhance(root) {
    root = root || document;
    enhanceAccordions(root);
    enhanceQuantitySteppers(root);
  }

  function run() {
    enhance(document);
    // GemPages-Komponenten (Akkordeons, Mengensteller) koennen nach
    // Variantenwechsel oder AJAX-Nachladen (z.B. Empfehlungen) neu
    // gerendert werden. Der :not([data-calo-a11y])-Filter oben macht
    // enhance() idempotent, deshalb genuegt ein einfacher
    // childList-Observer ohne eigene Endlosschleife.
    if ('MutationObserver' in window) {
      try {
        var observer = new MutationObserver(function (mutations) {
          for (var i = 0; i < mutations.length; i++) {
            if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
              enhance(document);
              return;
            }
          }
        });
        observer.observe(document.body, { childList: true, subtree: true });
      } catch (e) { /* kein Beobachten moeglich: Erstlauf bleibt trotzdem aktiv */ }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
